module.exports = __webpack_public_path__ + "img/restaurant.a083bd36.png";